import {Component, OnInit, TemplateRef, OnDestroy} from '@angular/core'
import {Observable, Subscription} from 'rxjs'
import {ContextService} from '@app/core/services/context.service'
import {tap, first, map} from 'rxjs/operators'
import {BreakpointState, BreakpointObserver} from '@angular/cdk/layout'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {AppAsideService} from '@app/features/page/app-aside/app-aside.service'

@Component({
  selector: 'pinned-domain-indicator',
  template: `
    <div>
      <button
        class="btn-transparent text-dark pinned-indicator"
        (click)="toggleTreeSelector(domainTreeModal)">
        {{ currentDomain$ | async }}&nbsp;<i class="icon icon-pin"></i>
      </button>
      <ng-template #domainTreeModal let-modal>
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
          <domain-tree (pinned)="onChanged()"></domain-tree>
        </div>
      </ng-template>
    </div>
  `,
  standalone: false,
})
export class PinnedDomainComponent implements OnInit, OnDestroy {
  currentDomain$: Observable<string>
  isSmallScreen$: Observable<BreakpointState>
  screenlistener: Subscription

  constructor(
    public context: ContextService,
    public breakpointObserver: BreakpointObserver,
    private ngModalService: NgbModal,
    public appAsideService: AppAsideService,
  ) {}

  ngOnInit() {
    this.isSmallScreen$ = this.breakpointObserver.observe([
      '(max-width: 767.98px)',
    ])
    this.ngModalService.dismissAll()
    this.currentDomain$ = this.context.activeDomain$
    this.screenlistener = this.isSmallScreen$
      .pipe(
        map((res) => {
          return res.matches
        }),
        tap((isSmall) => {
          // for resizing, just dismiss modal when screen is not small anymore
          if (!isSmall) {
            this.ngModalService.dismissAll()
          }
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    try {
      this.screenlistener.unsubscribe()
    } catch (e) {
      // no subscription present
    }
  }

  onChanged() {
    // hide modal on pinned event
    this.ngModalService.dismissAll()
  }

  toggleTreeSelector(domainTreeModal: TemplateRef<any>) {
    this.isSmallScreen$
      .pipe(
        first(),
        tap((res) => {
          if (res.matches) {
            this.ngModalService
              .open(domainTreeModal, {
                ariaLabelledBy: 'modal-domain-tree-view',
                windowClass: 'modal-holder modal-domain-tree',
                centered: true,
              })
              .result.then(
                (result) => {},
                () => {},
              )
          } else {
            this.appAsideService.toggleVisible()
          }
        }),
      )
      .subscribe()
  }
}
